<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t(moduleName)})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <li>
                <div class="uk-text-right">
                    <Button :action="actionNew" has-action mode="primary">
                        {{ $t('x.add', {x: $t(itemName)}) }}
                    </Button>
                </div>

                <div class="uk-margin-medium-top" />
                <div v-if="!computedList || computedList.length === 0">
                    {{ $t('none.x', {x: $t(formName)}) }}
                </div>
                <div v-else class="uk-overflow-auto">
                    <table
                        class="uk-table uk-table-middle uk-table-divider uk-table-hover">
                        <thead>
                            <tr>
                                <th class="uk-table-shrink">
                                    {{ $t('name') }}
                                </th>

                                <th class="uk-table-shrink">
                                    {{ $t('type') }}
                                </th>

                                <th class="uk-table-shrink">
                                    {{ $t('options') }}
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                :id="item.id"
                                v-for="(item, key) in computedList"
                                :key="'variant-' + key"
                                :class="
                                    'cursor-pointer uk-text-nowrap' +
                                    (item.id === hoveredId
                                        ? ' uk-table-hovered'
                                        : '')
                                ">
                                <td v-on:click="actionSelect(item)">
                                    <Modal
                                        :id="modalIdUpdate + item.id"
                                        :title="
                                            $t('x.change', {
                                                x: $t('variant'),
                                            })
                                        ">
                                        <VariantForm
                                            @declared="variantDeclared"
                                            :modal-id="modalIdUpdate + item.id"
                                            :variant="item"
                                            :disabled="disabled" />
                                    </Modal>

                                    <Icon
                                        class="uk-margin-small-right"
                                        icon="hashtag" />
                                    {{ item.name }}
                                </td>

                                <td v-on:click="actionSelect(item)">
                                    <Icon
                                        class="uk-margin-small-right"
                                        icon="settings" />
                                    {{ $t('variant.' + item.type) }}
                                </td>

                                <td v-on:click="actionSelect(item)">
                                    <Icon
                                        class="uk-margin-small-right"
                                        icon="list" />
                                    {{
                                        item.options.length +
                                        ' ' +
                                        $t(
                                            item.options.length === 1
                                                ? 'option'
                                                : 'options'
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="uk-margin-medium-top" />

                <div
                    v-if="computedList && computedList.length > 0"
                    class="uk-text-right">
                    <Button :action="actionNew" has-action mode="primary">
                        {{ $t('x.add', {x: $t(itemName)}) }}
                    </Button>
                </div>
            </li>

            <Modal :id="modalIdCreate" :title="$t('x.add', {x: $t(itemName)})">
                <VariantForm
                    id="new"
                    @declared="variantDeclared"
                    :modal-id="modalIdCreate"
                    :variant="{
                        id: null,

                        name: '',
                        type: 'select',

                        options: [
                            {
                                name: '',
                                price: 0,
                            },
                        ],
                    }"
                    :disabled="disabled" />
            </Modal>
        </span>
    </span>
</template>

<script>
import Button from '@/components/generic/Button.vue';
import UIkit from 'uikit';
import Icon from '@/components/generic/Icon.vue';
import Modal from '@/components/generic/Modal.vue';
import VariantForm from './VariantForm.vue';
import axios from 'axios';

export default {
    name: 'ClickAndBuyVariantsForm',
    components: {
        VariantForm,
        Icon,
        Modal,
        Button,
    },
    props: {
        disabled: Boolean,
    },
    computed: {
        computedList() {
            return this.list;
        },
    },
    data() {
        return {
            moduleName: 'clickandbuy',
            formName: 'variants',
            itemName: 'variant',

            list: [],
            modalIdCreate: 'modal-variant-create',
            modalIdUpdate: 'modal-variant-update-',
            hoveredId: 0,

            loading: true,
        };
    },
    created() {
        this.getVariants();
    },
    methods: {
        getVariants() {
            let http = axios.create();
            http.get(this.apiUrl + '/manage-variants/')
                .then((response) => {
                    this.list = response.data;

                    this.error = null;
                    this.loading = false;
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.loading = false;
                });
        },
        variantDeclared(id) {
            this.hoveredId = id;
            this.getVariants();
            this.$emit('declared', id);
        },
        actionNew() {
            this.selected = {};
            UIkit.modal('#' + this.modalIdCreate).show();
        },
        actionSelect(select) {
            this.selected = select;
            UIkit.modal('#' + this.modalIdUpdate + select.id).show();
        },
    },
};
</script>

<style lang="scss" scoped></style>
